<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="min-h-[var(--portal-vh,100dvh)] bg-background text-foreground">
    <RouterView />
  </div>
</template>
